import TabularDataTableRow from "./TabularDataTableRow";
import _ from "underscore";
import $ from "jquery";

function TabularDataWithEffectiveDatesTableRow() {}

TabularDataWithEffectiveDatesTableRow.prototype = _.create(TabularDataTableRow.prototype);

TabularDataWithEffectiveDatesTableRow.prototype.init = function()
{
    TabularDataTableRow.prototype.init.call( this );
    this.effective = false;
    this.inPast = false;
    return this;
};

TabularDataWithEffectiveDatesTableRow.prototype.setEffective = function( effective )
{
    this.effective = effective;
};

TabularDataWithEffectiveDatesTableRow.prototype.isEffective = function()
{
    return this.effective;
};

TabularDataWithEffectiveDatesTableRow.prototype.setInPast = function( inPast )
{
    this.inPast = inPast;
};

TabularDataWithEffectiveDatesTableRow.prototype.isInPast = function()
{
    return this.inPast;
};

TabularDataWithEffectiveDatesTableRow.prototype.getRowClasses = function()
{
    var classes = TabularDataTableRow.prototype.getRowClasses.call( this );
    if( !this.markedToRemove && this.effective )
        classes.push( "effective" );
    if( this.inPast )
        classes.push( "past" );
    return classes;
};

TabularDataWithEffectiveDatesTableRow.prototype.setDeleteConfirmation = function(isShown)
{
    this.deleteConfirmationShown = isShown;
};

TabularDataWithEffectiveDatesTableRow.prototype.updateUI = function()
{
    TabularDataTableRow.prototype.updateUI.call(this);
    $(this.getRowEl()).toggleClass("deleteConfirmation", !!this.deleteConfirmationShown);
};

TabularDataWithEffectiveDatesTableRow.prototype.hasErrors = function()
{
    return !_.every(this.cells, function(cell) {
        return !cell.isValid || cell.isValid();
    });
};

export default TabularDataWithEffectiveDatesTableRow;



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/TabularDataWithEffectiveDatesTableRow.js